(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantacore-collection-video"] && !Shopify.designMode) return;
  try {
    
  const startVantacoreVideos = (scope = document) => {
    scope.querySelectorAll('[data-vc-autoplay-video]').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');

      const playVideo = () => {
        if (document.hidden) return;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      };

      if (!video.dataset.vcAutoplayBound) {
        video.dataset.vcAutoplayBound = 'true';
        ['loadedmetadata', 'loadeddata', 'canplay'].forEach((eventName) => video.addEventListener(eventName, playVideo));
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          playVideo();
        });
        video.addEventListener('pause', () => {
          if (!document.hidden && !video.ended) window.setTimeout(playVideo, 150);
        });
      }

      playVideo();
      if (video.readyState < 2) video.load();
    });
  };

  startVantacoreVideos(document);
  document.addEventListener('DOMContentLoaded', () => startVantacoreVideos(document));
  document.addEventListener('shopify:section:load', (event) => startVantacoreVideos(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) startVantacoreVideos(document);
  });
  window.addEventListener('pageshow', () => startVantacoreVideos(document));
  window.addEventListener('focus', () => startVantacoreVideos(document));
  document.addEventListener('pointerdown', () => startVantacoreVideos(document), { once: true, passive: true });
  document.addEventListener('touchstart', () => startVantacoreVideos(document), { once: true, passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantacore-home-class-video"] && !Shopify.designMode) return;
  try {
    
  const startVantacoreHomeClassVideos = (scope = document) => {
    scope.querySelectorAll('[data-vc-home-class-autoplay]').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');

      const playVideo = () => {
        if (document.hidden) return;
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      };

      if (!video.dataset.vcHomeAutoplayBound) {
        video.dataset.vcHomeAutoplayBound = 'true';
        ['loadedmetadata', 'loadeddata', 'canplay'].forEach((eventName) => video.addEventListener(eventName, playVideo));
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          playVideo();
        });
        video.addEventListener('pause', () => {
          if (!document.hidden && !video.ended) window.setTimeout(playVideo, 150);
        });
      }

      playVideo();
      if (video.readyState < 2) video.load();
    });
  };

  startVantacoreHomeClassVideos(document);
  document.addEventListener('DOMContentLoaded', () => startVantacoreHomeClassVideos(document));
  document.addEventListener('shopify:section:load', (event) => startVantacoreHomeClassVideos(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) startVantacoreHomeClassVideos(document);
  });
  window.addEventListener('pageshow', () => startVantacoreHomeClassVideos(document));
  window.addEventListener('focus', () => startVantacoreHomeClassVideos(document));
  document.addEventListener('pointerdown', () => startVantacoreHomeClassVideos(document), { once: true, passive: true });
  document.addEventListener('touchstart', () => startVantacoreHomeClassVideos(document), { once: true, passive: true });

  } catch(e) { console.error(e); }
})();
})();
